import { FIELD_LABEL, OPERATOR_LABEL } from "./constants";

export const emptyConditionRow = () => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
  field: "toName",
  operator: "contains",
  value: "",
});

export function buildConditionsFromRows(rows) {
  const conditions = {};
  rows.forEach((row) => {
    const key = `${row.field}__${row.operator}`;
    if (row.value === "" || row.value === null || row.value === undefined) return;
    conditions[key] = row.value;
  });
  return conditions;
}

export function parseConditionsToRows(conditions) {
  const entries = Object.entries(conditions || {});
  if (!entries.length) return [emptyConditionRow()];
  return entries.map(([key, value]) => {
    const [field, operator] = key.split("__");
    return {
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      field: field || "toName",
      operator: operator || "contains",
      value: String(value),
    };
  });
}

export const emptyConditionGroup = (index = 0) => ({
  id: `${Date.now()}-group-${Math.random().toString(36).slice(2)}`,
  groupJoinOperator: index === 0 ? null : "AND",
  conditionLogicOperator: "AND",
  rows: [emptyConditionRow()],
});

export function parseConditionGroups(rule) {
  const groups = Array.isArray(rule?.conditionGroups) ? rule.conditionGroups : [];
  if (groups.length > 0) {
    return groups.map((group, index) => ({
      id: `${Date.now()}-group-${Math.random().toString(36).slice(2)}`,
      groupJoinOperator: index === 0 ? null : (group.groupJoinOperator || "AND"),
      conditionLogicOperator: group.conditionLogicOperator || "AND",
      rows: parseConditionsToRows(group.conditions || {}),
    }));
  }
  return [{
    ...emptyConditionGroup(0),
    rows: parseConditionsToRows(rule?.conditions),
  }];
}

export function buildConditionGroupsPayload(groups) {
  const payload = (groups || []).map((group, index) => ({
    groupOrder: index + 1,
    groupJoinOperator: index === 0 ? null : (group.groupJoinOperator || "AND"),
    conditionLogicOperator: group.conditionLogicOperator || "AND",
    conditions: buildConditionsFromRows(group.rows || []),
  }));
  return payload.filter((group) => Object.keys(group.conditions).length > 0);
}

export function conditionsToText(conditions) {
  const entries = Object.entries(conditions || {});
  if (!entries.length) return "default";
  return entries
    .map(([key, value]) => {
      const [field, op] = key.split("__");
      return `${FIELD_LABEL[field] || field} ${OPERATOR_LABEL[op] || op} ${String(value)}`;
    })
    .join(" ");
}

export function conditionGroupsToText(conditionGroups) {
  const groups = Array.isArray(conditionGroups) ? conditionGroups : [];
  if (!groups.length) return "";

  return groups
    .map((group, index) => {
      const join = index === 0 ? "" : ` ${group.groupJoinOperator || "AND"} `;
      const logic = group.conditionLogicOperator || "AND";
      const entries = Object.entries(group.conditions || {});
      if (!entries.length) return "";
      const body = entries
        .map(([key, value]) => {
          const [field, op] = key.split("__");
          return `${FIELD_LABEL[field] || field} ${OPERATOR_LABEL[op] || op} ${String(value)}`;
        })
        .join(` ${logic} `);
      return `${join}(${body})`;
    })
    .filter(Boolean)
    .join("")
    .trim();
}

export function ruleConditionsText(rule) {
  const groupsText = conditionGroupsToText(rule?.conditionGroups);
  if (groupsText) return groupsText;
  return conditionsToText(rule?.conditions);
}

export function normalizeText(value) {
  return String(value ?? "").toLowerCase();
}
